/** @param {HTMLElement} button */
export const addAddressLine = (button) => {
    const container  = button.closest('[data-address-lines]');
    const hiddenLine = container.querySelector('[data-address-line][hidden]');

    if (!hiddenLine) {
        return;
    }

    hiddenLine.removeAttribute('hidden');
    hiddenLine.querySelector('input')?.focus();

    if (!container.querySelector('[data-address-line][hidden]')) {
        button.hidden = true;
    }
};
